import { render } from "./applyBill.vue?vue&type=template&id=5276083d&scoped=true"
import script from "./applyBill.vue?vue&type=script&lang=js"
export * from "./applyBill.vue?vue&type=script&lang=js"

import "./applyBill.vue?vue&type=style&index=0&id=5276083d&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5276083d"]])

export default __exports__